<template>

    <form ref="aliquotasimplesnacional-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">

            <div class="form-group col-md-4">
                <label for="faixa">Faixa</label>
                <input type="text" class="form-control" name="faixa" placeholder="Nome da Faixa" v-model="model.faixa" required />
            </div>
            <div class="form-group col-md-4">
                <label for="inicioVigencia">Início Vigência</label>
                <input type="text" v-mask="'##/##/####'" v-datepicker class="form-control" name="inicioVigencia" placeholder="__/__/____" v-model="model.inicioVigencia" required />
            </div>
            <div class="form-group col-md-4">
                <label for="terminoVigencia">Término Vigência</label>
                <input type="text" v-mask="'##/##/####'" v-datepicker class="form-control" name="terminoVigencia" placeholder="__/__/____" v-model="model.terminoVigencia" />
            </div>
            <div class="form-group col-md-4">
                <label for="receitaBrutaAnualDe">Receita Bruta Anual (De)</label>
                <money v-bind="money" class="form-control" name="receitaBrutaAnualDe" placeholder="R$" v-model="model.receitaBrutaAnualDe" required />
            </div>
            <div class="form-group col-md-4">
                <label for="receitaBrutaAnualAte">Receita Bruta Anual (Até)</label>
                <money v-bind="money" class="form-control" name="receitaBrutaAnualAte" placeholder="R$" v-model="model.receitaBrutaAnualAte" required />
            </div>
            <div class="form-group col-md-4">
                <label for="aliquota">Alíquota</label>
                <money v-bind="money" class="form-control" name="aliquota" placeholder="%" v-model="model.aliquota" required />
            </div>
            <div class="form-group col-md-4">
                <label for="valorDeduzir">Valor a Deduzir</label>
                <money v-bind="money" class="form-control" name="valorDeduzir" placeholder="R$" v-model="model.valorDeduzir" required />
            </div>

        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "aliquotasimplesnacional-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {},

            form: "aliquotasimplesnacional-form-edit",

            resources: {
                edit: 'aliquotasimplesnacional',
            },

        }),

        methods: {

            executeEdit: function (model) {

                let dataInicio = document.getElementsByName('inicioVigencia')[1].value;
                if (dataInicio != '' && this.validarDatas(dataInicio) == 'Invalid Date') {
                    this.defaultErrorResult('Data de início da vigência não é válida, favor verificar!');
                    return;
                }

                let dataTermino = document.getElementsByName('terminoVigencia')[1].value;
                if (dataTermino != '' && this.validarDatas(dataTermino) == 'Invalid Date') {
                    this.defaultErrorResult('Data de término da vigência não é válida, favor verificar!');
                    return;
                }

                if (this.formValidate() == false) return;

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            },

            validarDatas: function (date) {
                let arrData = date.split('/');
                let stringDataFormatada = arrData[1] + '-' + arrData[0] + '-' + arrData[2];
                let newDate = new Date(stringDataFormatada);
                console.log(newDate);

                return newDate.toString();
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ aliquotaSimplesNacionalId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>